import * as React from "react";
import {useEffect} from "react";
import {LeadsStep} from "./LeadsStep";
import {useLeadStore} from "./store/Lead.store";
import './my-izen-leads-component.scss';
import useBelfiusTheme from "./theme/ThemeHooks";

// @ts-ignore
export const MyIzenLeadsComponent = ( {configuration} ) => {
    const store = useLeadStore();
    let {themeClassName} = useBelfiusTheme();

    useEffect( () => {
        store.initialize( {...configuration} );
    }, [store] );

    return (<div className={`mi-lead-generation-container ${themeClassName}`}>
        <LeadsStep/>
    </div>)
}
